/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Profile/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Content from './Content/index'
import EnsureUrl from 'DesignSystem/EnsureUrl/react'
import Menu from './Menu/index'
import React from 'react'
import Topbar from './Topbar/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Profile({
  children,
  viewPath = "/App/Account/Content/Profile"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral400 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.400'
        })
  return (<React.Fragment
>
<EnsureUrl
  viewPath={`${viewPath}/EnsureUrl`}
/>
<div
  data-testid="Profile.Vertical"
  data-view-path={viewPath}
 style={{'--bblr-1-1AREyJ': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-2-1AREyJ': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-3-1AREyJ': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-1AREyJ': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-1AREyJ': dtColorsWhite,'--bc-6-1AREyJ': dtColorsNeutral400}}
 className={`views-block ${styles.Vertical}`}
>
<Topbar
  viewPath={`${viewPath}/Topbar`}
/>
<div
  data-testid="Profile.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<Menu
  viewPath={`${viewPath}/Menu`}
/>
<Content
  viewPath={`${viewPath}/Content`}
/>
</div>
</div>
{children}
</React.Fragment>)
}